import BaseAPI from "@/api/BaseAPI";

export class ContactsAPI extends BaseAPI {
  constructor() {
    super('');
  }

  /**
   * @param {'founder'| 'region'} typeContact
   * @param {Number | ''} id
   * */
  getContact(typeContact, id) {
    if (typeContact === 'founder') { // TODO временно
      return this.http.get(`/${typeContact}/contact`, {
        data: {
          [typeContact + 'Id']: id === '' ? '' : id
        }
      })
    } else {
      return this.http.get(`/${typeContact}/getContact`, {
        data: {
          [typeContact + 'Id']: id === '' ? '' : id
        }
      })
    }
  }

  /**
   * @param {'region'} typeContact
   * */
  getContactFiles(typeContact) {
    return this.http.get(`/region/getContactFiles?userType=${typeContact}ID`)
  }

  /**
   * @param {{
   *       email: string,
   *       fio: string,
   *       position: string,
   *       workPhoneNumber: string,
   *       workPhoneExtension: string,
   *       personalPhoneNumber: string,
   *       personalPhoneExtension: string,
   *       typeContact: 'MAIN' | 'OTV'
   * }} data
   * @param {'founder'| 'region'} typeContact
   * */
  setContacts(data, typeContact) {
    if (typeContact === 'founder') { // TODO временно
      return this.http.post(`/${typeContact}`, {data})
    } else {
      return this.http.post(`/${typeContact}/setContact`, {data})
    }
  }

  /**
   * @param {number} orgId
   * */
  getOrganizationContact(orgId) {
    return this.http.get('/contact/byOrgId/get', {data: {orgId}})
  }

  setOrganizationContact(data) {
    return this.http.put('/contact/set', {data})
  }

  /**
   * @param {number} id
   * */
  deleteOrganizationContact(id) {
    return this.http.delete('/contact/delete', {data: {id}})
  }
}

export default new ContactsAPI()